module.exports = __webpack_public_path__ + "static/assets/1e4ca64432a875346e0b3fe2828b50ae.svg";